<form [formGroup]="parentForm" ngScrollToFirstInvalid class="localisation-representant-container">
  <label for="input-localisation-representant">
    {{ 'preautorisation.form-rdv.trouver-ville' | translate }}
  </label>
  <mat-form-field class="autocomplete-form-field" [formGroup]="parentForm" appearance="outline" floatLabel="always">
    <input
      type="text"
      matInput
      id="input-localisation-representant"
      formControlName="localisationRepresentant"
      [matAutocomplete]="auto"
      (focus)="isFieldFocused = true"
      (blur)="isFieldFocused = false"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="sentences"
      spellcheck="false"
      #autocompleteInput
    />
    <div matSuffix (click)="clearInput()" id="btn-effacer-autocomplete">
      <img
        [ngClass]="{ hidden: !isClearButtonVisible }"
        src="{{ 'assets/images/icone-close.svg' | cheminAbsoluStatique }}"
        width="15"
        height="15"
        alt=""
      />
    </div>
    <mat-error
      id="erreur-input-localisation-representant"
      *ngIf="
        parentForm.controls['localisationRepresentant'].errors?.noSelection ||
        parentForm.controls['localisationRepresentant'].errors?.required
      "
    >
      {{ 'erreur.champ-obligatoire' | translate }}
    </mat-error>
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="formatLocalisationDisplay"
      (optionSelected)="resetInputScroll(autocompleteInput)"
    >
      <mat-option
        *ngFor="let option of filteredLocalisations | async"
        class="autocomplete-option"
        [value]="option"
        [id]="'localisation-representant-' + option.id"
      >
        {{ option.description }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
